// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__T97YW","cardPadding":"Card_cardPadding__JA3_m","cardLink":"Card_cardLink__d08Kb"};